export const getCustomerSearch = async (setter, term) => {
  return fetch(`/api/forms/misc/getCustomerSearch?term=${term}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson.recordset);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getCustomerAddress = async (setter, id) => {
  return fetch(`/api/forms/misc/getCustomerAddress?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson.recordset);
      setter(responseJson.recordset);
    })
    .catch((error) => {
      //console.error(error);
    });
};

/*
  Promise-returning variants of the two lookups above. The setter-only helpers
  swallow failures, which leaves a caller unable to tell "still loading" from
  "Bistrack is down" — the RFQ intake wizard shows both states inline, so it
  needs the rejection. These also encode the query so names containing & or #
  don't truncate the search term.
*/
export const searchCustomers = async (term) => {
  const response = await fetch(
    `/api/forms/misc/getCustomerSearch?term=${encodeURIComponent(term)}`
  );
  if (!response.ok) {
    throw new Error(`Customer search failed (${response.status})`);
  }
  const body = await response.json();
  return body?.recordset || [];
};

export const fetchCustomerAddresses = async (customerId) => {
  const response = await fetch(
    `/api/forms/misc/getCustomerAddress?id=${encodeURIComponent(customerId)}`
  );
  if (!response.ok) {
    throw new Error(`Address lookup failed (${response.status})`);
  }
  const body = await response.json();
  return body?.recordset || [];
};

// A draft is only worth saving once the user has actually entered something —
// without this, just opening a form page creates an empty draft row on
// "My Forms".
export const hasDraftContent = (data) => {
  if (!data) return false;
  return Boolean(
    data.customer ||
      data.account ||
      data.job ||
      data.shipping_date ||
      data.special_instructions ||
      data.doorData?.length ||
      Object.keys(data.custom_fields || {}).length
  );
};

export const formAutoSave = async (data, setter) => {
  //Delete ID so Mongo is happy. (Prevents trying to overwrite the existing _id which will crash Mongo)
  delete data._id;

  var data = JSON.stringify(data);

  const rawResponse = await fetch("/api/forms/misc/autosave", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();

  setter(content.formID);
};

export const getPricing = async (
  data,
  isDouble,
  jamb,
  setter,
  ftwayne_prep
) => {
  // The prep adder is applied server-side (Admin-editable on
  // /admin/doors/pricing); this just tells the server whether it applies.
  const prep = ftwayne_prep === true || ftwayne_prep === "true" ? 1 : 0;

  return fetch(
    `/api/doors/kits/quotePricing?priceList=${data}&isDouble=${isDouble}&jamb=${jamb}&prep=${prep}`
  )
    .then((response) => response.json())
    .then(async (responseJson) => {
      //console.log(responseJson.recordset);
      await setter(
        Math.round((responseJson.pricing + Number.EPSILON) * 100) / 100
      );
    })
    .catch((error) => {
      //console.error(error);
    });
};
